// extracted by mini-css-extract-plugin
export var externalLinkIcon = "_sl-5";
export var filledCircle = "_sl-4";
export var historyEntry = "_sl-3";
export var messageSideLeft = "_sl-1";
export var messageSideRight = "_sl-2";
export var orderTrackingCarouselWrapper = "_sl-6";
export var orderTrackingInfoContainer = "_sl-0";